/* import __COLOCATED_TEMPLATE__ from './split-test-title.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();